import objectFitImages from 'object-fit-images';
import detectTouch from './utilities/detect-touch';
import breakpoints from './utilities/breakpoints';
import onScroll from './modules/onscroll';
import collapsible from './modules/collapsible';
import nav from '../components/nav/scripts';
import gallery from '../components/gallery/scripts';
import modal from '../components/modal/scripts';
import listing from '../components/listing/scripts';

// The vendor folder automatically gets bundled first.
// This is for the sort of stuff that isn't available via npm.

// Polyfills
require("babel-polyfill");
objectFitImages();

// Utilities
breakpoints.set();
window.onresize = () => breakpoints.set();

// Initialize
window.onload = function() {
	onScroll();
	detectTouch();
	nav();
	collapsible();
	listing();
	gallery();
	modal();
}
